// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1vRS9","title":"Info_title__3hL9I","links":"Info_links__24OMH","link":"Info_link__1yjHL","logo":"Info_logo__22GFW"};